import { Pipe, PipeTransform } from '@angular/core';
import {UserService} from "../../core/services/user/user.service";
import {InternationalizationService} from "../../core/services/internationalization/internationalization.service";

@Pipe({
  name: 'userDate'
})
export class UserDatePipe implements PipeTransform {

  constructor(private userService: UserService, private i18nService: InternationalizationService){}

  transform(longDate: string) {
    const date = new Date(longDate);
    const timezone = this.userService.getTimeZone();
    const zonedDate = this.i18nService.toLocaleDateOfTimezone(date, timezone);
    return this.i18nService.formatLongDateTime(zonedDate);
  }
}
